import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import instrumentationKeys from "./instrumentationKeys";

let appInsights = null;

const initialise = () => {
  try {
    // Get the current origin/URL
    const currentUrl = window.location.origin;
    
    // Look up the instrumentation key for this environment
    const ikey = instrumentationKeys[currentUrl];
    
    // If no key is configured, log a warning and return
    if (!ikey) {
      console.warn(`Application Insights: No instrumentation key configured for ${currentUrl}`);
      return;
    }

    // Initialize Application Insights SDK
    const reactPlugin = new ReactPlugin();
    
    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: ikey,
        enableAutoRouteTracking: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: [
          "*.blob.core.windows.net",
          "*.applicationinsights.io"
        ],
        maxBatchSizeInBytes: 10000,
        extensions: [reactPlugin]
      }
    });

    appInsights.loadAppInsights();
    appInsights.trackPageView();
    
    // Send a test event to verify telemetry is working
    appInsights.trackEvent({ 
      name: "AppStarted",
      properties: {
        environment: currentUrl,
        timestamp: new Date().toISOString(),
        version: "1.0"
      }
    });
    
    console.info(`Application Insights initialized successfully for ${currentUrl}`);
  } catch (error) {
    console.error("Failed to initialize Application Insights:", error);
  }
};

export default { initialise };
